import * as React from 'react';
export const useRefLazy = r => {
  const ref = React.useRef(null);

  if (ref.current === null) {
    ref.current = r();
  }

  return ref;
};
//# sourceMappingURL=useRefLazy.js.map